import { FullDealAndPing3OffersPage } from 'pageModules/FullDealAndPing3OffersPage';

export default FullDealAndPing3OffersPage;
